// extracted by mini-css-extract-plugin
module.exports = {"input":"searchInput_input__2B__q","inputdark":"searchInput_inputdark__2_S1G"};